import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation/Navigation';
import HomePage from './views/HomePage/HomePage';
import { ThemeProvider } from './theme/ThemeContext';

import './App.css';

// Lazy-load every route except the home page so the initial bundle stays small
const GameField = lazy(() => import('./views/GameField/GameField'));
const EndSummary = lazy(() => import('./views/EndSummary/EndSummary'));
const ContactPage = lazy(() => import('./views/ContactPage/ContactPage'));
const Projects = lazy(() => import('./views/Projects/Projects'));
const TechStack = lazy(() => import('./views/TechStack/TechStack'));
const ExperienceSection = lazy(() => import('./views/Experience/Experience'));

// Wrapper component for navigation with score
const AppContent: React.FC = () => {
  const [score, setScore] = useState(0);
  const location = useLocation();
  const isGameField = location.pathname === '/game';

  return (
    <div className="app">
      {/* Navigation Bar */}
      <Navigation score={isGameField ? score : undefined} />
      {/* Main App Routes */}
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/game" element={<GameField setAppScore={setScore} />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path='/experience' element={<ExperienceSection />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/techstack" element={<TechStack />} />
          <Route path="/summary" element={<EndSummary />} />
        </Routes>
      </Suspense>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
};

export default App;
